var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { licenseStatusesSelectValues } from '../../../../backend/constants';
import { useCredentialingTranslation } from '../../../../ui/hooks';
import { useFilterConfig } from '@juvare/common-data-table-ui/FiltersBar';
import { useAccountFilterConfig, useResolvedAdvancedSearchItems } from '@juvare/contact-management/ui/features/accounts/hooks';
import { useContactManagementTranslation } from '@juvare/contact-management/ui/hooks/useContactManagementTranslation';
import { ContactManagementConfigContext } from '@juvare/contact-management/ui/providers';
import React from 'react';
export function useLicenseCheckLatestStatusFilterConfig(userDisplayName) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { accountsTableCustomization } = React.useContext(ContactManagementConfigContext);
    const { t } = useCredentialingTranslation();
    const { t: tContactManagement } = useContactManagementTranslation();
    const defaultAdvancedSearchItems = useResolvedAdvancedSearchItems();
    const licenseCheckLatestStatusFilterConfig = useFilterConfig((builder) => {
        var _a;
        (_a = accountsTableCustomization === null || accountsTableCustomization === void 0 ? void 0 : accountsTableCustomization.extendFilters) === null || _a === void 0 ? void 0 : _a.call(accountsTableCustomization, builder);
        const licenseStatusesWidget = builder.findAllFiltersWidget('licenseStatuses');
        if (licenseStatusesWidget) {
            licenseStatusesWidget.key = 'statuses';
        }
        builder.quickFilterMultiSelect({
            label: t('table.credentialingVerification.occupation'),
            dataPath: 'occupationIds',
            widget: 'form.checkboxList',
            valueProvider: {
                type: 'classifier.occupation',
            },
            sx: { maxWidth: { xs: undefined, sm: 450 } },
        });
        builder.quickFilterMultiSelect({
            label: t('table.credentialingVerification.credentialName'),
            dataPath: 'credentialNames',
            widget: 'form.checkboxList',
            valueProvider: {
                type: 'classifier.occupationCredentialNames',
            },
            sx: { maxWidth: { xs: undefined, sm: 450 } },
        });
        builder.quickFilterMultiSelect({
            label: t('table.credentialingVerification.status'),
            dataPath: 'statuses',
            widget: 'form.checkboxList',
            values: licenseStatusesSelectValues,
            sx: { maxWidth: { xs: undefined, sm: 450 } },
        });
        builder.allFiltersPanel({
            label: t('table.credentialingVerification.requestDate'),
            children: [
                builder.allFiltersWidget({
                    label: t('table.credentialingVerification.filterLabels.requestedAfter'),
                    type: 'form.dateTimePicker',
                    key: 'requestedAfter',
                }),
                builder.allFiltersWidget({
                    label: t('table.credentialingVerification.filterLabels.requestedBefore'),
                    type: 'form.dateTimePicker',
                    key: 'requestedBefore',
                }),
            ],
        });
        builder.allFiltersPanel({
            label: t('table.credentialingVerification.requestedBy'),
            children: [
                builder.allFiltersWidget({
                    label: t('table.credentialingVerification.requestedBy'),
                    type: 'form.select',
                    key: 'requestedBy',
                    values: [
                        {
                            label: t('table.credentialingVerification.me'),
                            value: userDisplayName !== null && userDisplayName !== void 0 ? userDisplayName : '',
                        },
                        {
                            label: t('table.credentialingVerification.dailyVerificationSystem'),
                            value: 'System User',
                        },
                    ],
                }),
            ],
        });
    }, [accountsTableCustomization, t, userDisplayName]);
    const accountFilterConfig = useAccountFilterConfig({
        advancedSearchItems: defaultAdvancedSearchItems,
        showAccountSystemRoleFilter: 'onlyAllFiltersPanel',
        extendFilters: (builder) => {
            const searchWidget = builder.findAllFiltersWidget('partialSearch');
            if (searchWidget) {
                searchWidget.key = 'credentialSearch';
                builder.removeQuickFilter('partialSearch');
            }
            builder.quickAdvancedSearchFilter({
                search: {
                    dataPath: 'credentialSearch',
                    label: t('common.search'),
                    sx: { maxWidth: { xs: undefined, sm: 340 } },
                },
                advancedSearch: {
                    dataPath: 'advanced',
                    field: {
                        dataPath: 'field',
                        label: tContactManagement('panels.accounts.filterLabels.advanced.field'),
                        options: defaultAdvancedSearchItems.map((item) => ({
                            label: item.label,
                            value: item.value,
                            operatorOptions: item.operatorOptions,
                        })),
                    },
                    operator: {
                        dataPath: 'operator',
                        label: tContactManagement('panels.accounts.filterLabels.advanced.operator'),
                    },
                    value: {
                        dataPath: 'value',
                        label: tContactManagement('panels.accounts.filterLabels.advanced.value'),
                    },
                },
            });
        },
    });
    // TODO: Ideally, combining formConfig should be handled in common-data-table-ui - CUI-541
    return {
        allFilters: ((_a = accountFilterConfig.allFilters) === null || _a === void 0 ? void 0 : _a.children) || ((_b = licenseCheckLatestStatusFilterConfig === null || licenseCheckLatestStatusFilterConfig === void 0 ? void 0 : licenseCheckLatestStatusFilterConfig.allFilters) === null || _b === void 0 ? void 0 : _b.children)
            ? {
                type: 'filter.form',
                children: [
                    ...((_d = (_c = accountFilterConfig.allFilters) === null || _c === void 0 ? void 0 : _c.children) !== null && _d !== void 0 ? _d : []),
                    ...((_f = (_e = licenseCheckLatestStatusFilterConfig === null || licenseCheckLatestStatusFilterConfig === void 0 ? void 0 : licenseCheckLatestStatusFilterConfig.allFilters) === null || _e === void 0 ? void 0 : _e.children) !== null && _f !== void 0 ? _f : []),
                ],
            }
            : undefined,
        getFilterChips: accountFilterConfig.getFilterChips || licenseCheckLatestStatusFilterConfig.getFilterChips
            ? (...params) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c, _d;
                const accountFilterChips = (_b = (yield ((_a = accountFilterConfig.getFilterChips) === null || _a === void 0 ? void 0 : _a.call(accountFilterConfig, ...params)))) !== null && _b !== void 0 ? _b : [];
                const licenseCheckLatestStatusFilterChips = (_d = (yield ((_c = licenseCheckLatestStatusFilterConfig.getFilterChips) === null || _c === void 0 ? void 0 : _c.call(licenseCheckLatestStatusFilterConfig, ...params)))) !== null && _d !== void 0 ? _d : [];
                return [...accountFilterChips, ...licenseCheckLatestStatusFilterChips].reduce((acc, chip) => {
                    if (acc.some(({ groupId, label }) => groupId === chip.groupId && label === chip.label)) {
                        return acc;
                    }
                    return [...acc, chip];
                }, []);
            })
            : undefined,
        quickFilters: accountFilterConfig.quickFilters || licenseCheckLatestStatusFilterConfig.quickFilters
            ? [...((_g = accountFilterConfig.quickFilters) !== null && _g !== void 0 ? _g : []), ...((_h = licenseCheckLatestStatusFilterConfig.quickFilters) !== null && _h !== void 0 ? _h : [])]
            : undefined,
        filterDependencies: accountFilterConfig.filterDependencies || licenseCheckLatestStatusFilterConfig.filterDependencies
            ? Object.assign(Object.assign({}, ((_j = accountFilterConfig.filterDependencies) !== null && _j !== void 0 ? _j : {})), ((_k = licenseCheckLatestStatusFilterConfig.filterDependencies) !== null && _k !== void 0 ? _k : {})) : undefined,
    };
}
